import { Box } from "@mui/material";
import Button from "../../../design/Button";
import colors from "../../../design/colors";
import styles from "../../../design/styles";
import customStyles from "./styles";
import { initiateOrAcceptCallIcon } from "../../../../utility-functions/assetLoader";

const NumberVerified = ({ phoneNumber, onCallNow }) => {
  return (
    <Box
      sx={customStyles.container}
    >
      <Box
        sx={customStyles.numberVerifiedContent}
      >
        <p
          className="t6 medium-font nc-gray-900"
          style={customStyles.pl1}
        >
          Number verified
        </p>
        <p
          className="t7 regular-font nc-gray-700"
          style={customStyles.pl2}
        >
          {phoneNumber} has been added to your verified number list.
        </p>
        <p
          className="t7 regular-font nc-gray-700"
          style={customStyles.pl2}
        >
          You can now call this number anytime during your trial.
        </p>
      </Box>

      {/* Call now button */}
      <Box
        sx={{
          padding: "12px 18px 12px 18px",
        }}
      >
        <Button
          hierarchy="green"
          variant="contained"
          buttonText="Call now"
          disabled={false}
          onClick={onCallNow}
          icon={{
            startIcon: initiateOrAcceptCallIcon(colors.ic_white),
            endIcon: null,
          }}
          styleOverride={{
            width: "100%",
            height: "40px",
            ...styles.b1,
            ...styles.medium_font,
            color: colors.ic_white,
            backgroundColor: colors.ic_green_300,
          }}
        />
      </Box>
    </Box>
  );
};

export default NumberVerified;
